export default "__VITE_ASSET__D3jsPi76__"